import * as React from "react";

const Battery = (props: { color?: string; size?: number }): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.size ?? 16}
        height={props.size ?? 16}
        viewBox="0 0 16 16"
        fill="none"
    >
        <mask id="path-1-inside-1_27_2245" fill="white">
            <rect x="2" y="5" width="10" height="6" rx="1" />
        </mask>
        <rect
            x="2"
            y="5"
            width="10"
            height="6"
            rx="1"
            stroke={props.color ?? "#00A525"}
            strokeWidth="2.66"
            mask="url(#path-1-inside-1_27_2245)"
        />
        <path d="M13 7C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9V7Z" fill={props.color ?? "#00A525"} />
    </svg>
);

export default Battery;
